import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import AllVendor from '../../component/allvendor/AllVendor';
import UserHeader from '../../component/reusable/UserHeader';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import Cards from '../../component/reusable/Cards';
import AllBomOrderTable from '../../component/bomComps/AllBomOrderTable';
import BomOrderCard from '../../component/bomComps/BomOrderCard';
import BomOrderTab from '../../component/bomComps/BomOrderTab';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import { deletebomOrderThunk, exportbomOrderThunk, getAllBomOrderThunk, getbomOrderStatisticsThunk, setbomOrderFromDate, setbomOrderPage, setbomOrderSearch, setbomOrderSelectedTab, setbomOrderToDate } from '../../redux/bomOrderSlice';
import BomOrderFilter from '../../component/bomComps/BomOrderFilter';
import { deleteVendorOrderThunk, exportVendorOrderThunk, getAllVendorOrderThunk, getVendorOrderStatisticsThunk, setVendorOrderFromDate, setVendorOrderPage, setVendorOrderSearch, setVendorOrderSelectedTab, setVendorOrderToDate } from '../../redux/vendor/vendororderSlice';



function VendorBomOrders() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [orders, setOrder] = useState('dsc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const deleteCategory = (password) => {
        dispatch(deleteVendorOrderThunk({ id: selectedId, password }))
        setIsModalOpen(false);

    }


    //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };

    const handleChange = (event, newValue) => {
        dispatch(setVendorOrderSelectedTab(newValue))
        setAllStatus('')
        dispatch(setVendorOrderSearch(''))
        dispatch(setVendorOrderFromDate(''))
        dispatch(setVendorOrderPage(1))
        dispatch(setVendorOrderToDate(''))
    };



    const { order, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, orderStatistics } = useSelector((state) => state.vendorOrder);
    const orderData = order?.data
    const totalPages = order?.totalPages
    const totalItems = order?.totalItems
    const itemsPerPage = order?.limit

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'DELIVERED' : "CANCELLED"

    //    console.log(order);

    useEffect(() => {
        dispatch(getAllVendorOrderThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${orders}&orderType=BOM`));
    }, [page, search, status, limit, refresh, sortBy, orders, fromDate, toDate]);

    useEffect(() => {
        dispatch(getVendorOrderStatisticsThunk(`?orderType=BOM`))
    }, [])

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportvendorOrder = async () => {
        const status = await dispatch(exportVendorOrderThunk(`?limit=${10000000000000}&orderType=BOM`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',
                'Total': item?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "order")
        }
    }



    return (
        <>
            <UserHeader
                index="Vendor Orders"
                root="Dashboard"
                exportData={exportvendorOrder}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />

            <BomOrderCard
                orderStatistics={orderStatistics}
            />

            <Box>

                <BomOrderTab handleChange={handleChange} selectedTab={selectedTab} />
                <BomOrderFilter
                    setAllStatus={setAllStatus}
                    search={search}
                    selectedTab={selectedTab}
                    setOrderFromDate={setbomOrderFromDate}
                    setOrderToDate={setbomOrderToDate}
                    setSearch={setbomOrderSearch}
                />

                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {orderData?.length > 0 ?
                                    <Typography>
                                        <AllBomOrderTable
                                            bomData={orderData}
                                            page={page}
                                            setPage={setVendorOrderPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            selectedTab={selectedTab}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/bom/VendorBomOrderDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default VendorBomOrders;
